<template>
<div
    class="modal two-factor-auth-enable-modal"
    :class="{ 'is-active': show }"
>
    <div class="modal-background" @click="hideModal"></div>
    <div class="modal-card">

        <header class="modal-card-head">
            <p class="modal-card-title">
                {{ trans.two_factor_auth }}
            </p>
            <button
                class="delete"
                aria-label="close"
                @click="hideModal"
            ></button>
        </header>

        <section
            class="modal-card-body"
            v-show="qrCodeUrl || secret"
            @input="clearValidation"
        >
            <div class="content">
                <div>
                    <h6>
                        {{ trans.two_factor_instruction_title }}
                    </h6>
                    <div
                        class="content is-size-7"
                        v-html="trans.two_factor_instruction_text"
                    ></div>
                </div>
                <div class="columns has-text-centered">
                    <div class="column is-6-desktop" v-if="qrCodeUrl">
                        <img :src="qrCodeUrl" alt="QR">
                    </div>
                    <div
                        class="two-factor-secret column is-6-desktop has-text-left is-vcentered"
                        v-show="secret"
                    >
                        {{ trans.secret_key }}: <p>{{ secret }}</p>
                    </div>
                </div>

                <div class="field is-horizontal field-label-container">
                    <label for="one-time-password" class="field-label is-normal">
                        {{ trans.confirmation_code }}
                    </label>

                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    id="one-time-password"
                                    type="text"
                                    class="input"
                                    name="one_time_password"
                                    autocomplete="off"
                                    required
                                    :class="{ 'is-danger': errors.one_time_password }"
                                    :placeholder="trans.confirmation_code_placeholder"
                                    v-model="form.one_time_password"
                                    @keyup.enter="enable"
                                >
                            </div>
                            <p v-show="errors.secret || errors.one_time_password" class="help is-danger">
                                {{ errors.secret || errors.one_time_password }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <footer class="modal-card-foot">
            <button
                class="button is-info"
                :class="{ 'is-loading': isLoading }"
                @click="enable"
            >
                {{ trans.enable }}
            </button>
            <button class="button" @click="hideModal">
                {{ trans.cancel }}
            </button>
            <p v-show="errors.unexpected" class="help is-danger">
                {{ errors.unexpected }}
            </p>
        </footer>
    </div>
</div>
</template>

<script>
    import { axiosForm } from '../mixins/axiosFormMixin';
    import passwordVerifyMixin from "../mixins/passwordVerifyMixin";
    import {mapActions, mapState} from "vuex";

    export default {
        mixins: [
            axiosForm,
            passwordVerifyMixin,
        ],
        props: {
            actions: Object,
        },
        data() {
            return {
                form: {
                    secret: null,
                    one_time_password: null,
                },
                qrCodeUrl: null,
                okReport: 'Активация двухфакторной аутентификации',
                failReport: 'Ошибка активации двухфакторной аутентификации',
            };
        },
        watch: {
            show() {
                // Если 2fa уже активна
                if (this.twoFactorAuth.enabled) {
                    this.hideModal();
                    return;
                }

                if (this.qrCodeUrl) return;

                this.getQrCodeUrl();
            },
        },
        computed: {
            /**
             * Секретный ключ 2FA
             * @returns String
             */
            secret() {
                try {
                    // Разобьем ключ на блоки по 4 символа для удобства пользователя
                    return this.form.secret.replace(/(.{4})/g, '$1 ');
                } catch {}
            },

            ...mapState('passwordVerify', ['password']),
            ...mapState('twoFactorAuthEnableModal', ['show', 'twoFactorAuth']),
        },
        methods: {

            /**
             * Обработчик нажатия кнопки активации 2FA
             */
            enable(e) {
                this.submit(e, this.actions.enable);
            },
            /**
             * Получение URL адреса QR кода
             */
            getQrCodeUrl() {
                this.isLoading = true;
                axios.post(this.actions.secret, this.form)
                    .then(response => {
                        this.qrCodeUrl = response.data.qr_url;
                        this.form.secret = response.data.secret;
                    })
                    .catch(error => {
                        this.errors.unexpected = this.trans.unexpected_error;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    })
            },

            /**
             * Обработчик ответа сервера на запрос активации
             */
            postResultHandler(response) {
                if (response.data.enabled) {
                    this.enableTwoFactor();
                    this.clearModalData();
                    this.hideModal();
                }
            },

            /**
             * Процедура очистки данных в модальном окне
             */
            clearModalData() {
                this.form.secret = null;
                this.form.one_time_password = null;
                this.qrCodeUrl = null;
            },

            ...mapActions('twoFactorAuthEnableModal', {
                hideModal: 'hideModal',
                enableTwoFactor: 'enable'
            }),
        },
    }
</script>
